import React, { Component } from 'react';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Tooltip
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';

class EmployerSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state ={
      searchTextField :  !this.props.searchTypeValue ? "":this.props.searchText,
    }
  }
  onChangeSearchTextField = (e) => {
    this.setState({searchTextField: e.target.value}, () => {
      if (this.state.searchTextField === "" || this.state.searchTextField === null) {
        this.props.searchRecord();
    }
    });
  }
  render() {
    const {
      searchTypeValue,
      searchText,
      targetDate,
      handleChangeSearchType,
      handleDate,
      setSearch,
      searchRecord,
      addEmployerModal,
      refreshEmployer,
      CrudButton,
      customStyle = {}
    } = this.props;
    const {searchTextField = ""} = this.state;
    const filterSearch= [
      "Date Added",
      "Company Name",
    ]
    return (
    
        <Grid  container style={{ padding: '10px', background: "#d5d6e9" }}>
          <Grid item xs={2} sm={2} style={{paddingRight:10}}>
            <FormControl variant="filled" style={customStyle.formControlStyle}>
              <InputLabel style={{ textAlign: 'left' }}>Search By</InputLabel>
              <Select
                name="name"
                value={searchTypeValue}
                onChange={handleChangeSearchType}
              >
                <MenuItem value='0'>Date Added</MenuItem>
                <MenuItem value='1'>Company Name</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={2}>
            {searchTypeValue === '0' ? (
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="none"
                  label="Select Date"
                  format="MMMM dd,yyyy"
                  value={targetDate}
                  onFocus={e => e.target.blur()}
                  inputProps={{
                    style: {
                      fontSize: '12.8px',
                      fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                      marginTop: '3px',
                      width: '100%'
                    }
                  }}
                  InputLabelProps={{
                    style: {
                      paddingRight: 10,
                      paddingTop: 0,
                      color: 'grey',
                      width: '100%'
                    }
                  }}
                  onChange={handleDate}
                  variant="filled"
                  inputVariant="filled"
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  views={["year", "month", "date"]}
                  openTo="year"
                  minDate={new Date('01/01/2020')}
                />
              </MuiPickersUtilsProvider>
            ) : (
              <FormControl variant="filled" style={customStyle.formControlStyle} fullWidth>
              <TextField
              label={"Search By " + (searchTypeValue ? "Company Name" : "")}
                style={{ marginTop: '0px', width: "100%" }}
                value={this.state.searchTextField}
                disabled={!searchTypeValue}
                variant="filled"
                // onChange={setSearch}
                onChange={(e) => this.onChangeSearchTextField(e)}
                onKeyDown={(event)=>{
                  if (event.keyCode == '13') {
                      searchRecord(searchTextField)
                  } 
                  
              }}
              />
              </FormControl>
            )}
          </Grid>

          <Grid item xs={1} sm={1} style={{ paddingLeft: 10 }}>
            <Tooltip title="Search" placement="bottom">
              <CrudButton
                color="secondary"
                style={{ marginTop: '7px', boxShadow: 'none', width: '46px', height: '46px' }}
                aria-label="search"
                disabled={searchTextField === '' || targetDate === ''}
                onClick={() => searchRecord(searchTextField)}
              >
                <SearchIcon />
              </CrudButton>
            </Tooltip>
          </Grid>

          <Grid item xs={1} sm={5} />

          <Grid item xs={1} sm={2} style={{display: "flex", justifyContent: 'flex-end',}}>
            <Tooltip title="Add Employer" placement="bottom">
              <CrudButton
                color="primary"
                aria-label="add"
                style={{
                  width: '46px',
                  height: '46px',
                  boxShadow: 'none',
                  marginTop: '7px',
                  marginRight:10,
                  marginLeft: '3%',
                  // backgroundColor: '#e10050'
                }}
                onClick={addEmployerModal}
              >
                <AddIcon />
              </CrudButton>
            </Tooltip>
            <Tooltip title="Refresh" placement="bottom">
              <CrudButton
                style={{
                  boxShadow: 'none',
                  width: '46px',
                  height: '46px',
                  marginTop: '7px',
                  // backgroundColor: '#41b5c2'
                }}
                onClick={() => {
                  this.setState({searchTextField: "", }, () => {
                    refreshEmployer();
                  })
                  }}
              >
                <RefreshIcon />
              </CrudButton>
            </Tooltip>
          </Grid>

       
        </Grid>

    );
  }
}

export default EmployerSearchBar;
